const variant = process.env.REACT_APP_VARIANT;
console.log("Variant:", variant);

let routes;

switch (variant) {
  case "Version1":
    routes = require("./router.linkV1");
    break;
  case "Version2":
    routes = require("./router.link");
    break;
  default:
    routes = require("./router.link");
}

export const { publicRoutes, posRoutes, pagesRoute } = routes;
